<template>
  <div class="new-home">
    <div class="banner-container" :style="{'background': 'url(' + clients.backgroundImg+ ')'}">
      <video v-if="bgType=='mp4'||bgType=='MP4'" autoplay muted playsinline loop style='object-fit: cover;' class="video-bg"> 
        <source :src="clients.backgroundImg" type="video/mp4" />
         <!-- <source src="https://v.libraryplus.bjadks.com/shuzijiyi/video/ce711d5ed40c9c69d094c2fb28d247e2.mp4" type="video/mp4" /> -->
     </video>
      <div class="search-wrap">
        <span class="font-color-white font-size-60 banner-title">{{clients.clinetTitleMain}}</span>
        <div class="search-input bg-white radius-clip-5">
          <div class="flex-1 input">
            <input
              class="font-size-16"
              :placeholder="collectionCountText"
              type="text"
              @input="inputChane"
              @keyup.enter="toSearch"
            />
          </div>
          <div class="search-input-button radius-clip-5 flex-center cursor" @click="toSearch">
            <!-- <img src="../../../../assets/icon-lib-search-sm.png">
            <span class="font-color-white font-size-16">搜索</span>-->
            <img src="@/assets/searchs.png" alt />
          </div>
        </div>
        {{resourceCount}}
        <div class="num-container">
          <div class="num-item" v-for="(item,index) in resourceCount" :key="index">
            <countTo :startVal='startVal' :endVal='item.count' :duration='3000'></countTo>
            <!-- <span>{{item.count}}</span> -->
            <span>{{item.resourceType=='image'?'图片馆藏':item.resourceType=='audio'?'音频馆藏':'视频馆藏'}}</span>
          </div>
          <!-- <div class="num-item">
                        <span>18432</span>
                        <span>视频馆藏</span>
                    </div>
                    <div class="num-item">
                        <span>8475</span>
                        <span>音频馆藏</span>
          </div>-->
        </div>
      </div>
    </div>
    <div class="subject-and-special">
      <div style="border-bottom: solid 1px #EFEFEF;">
        <div class="subject_navbar">
          <span
            v-for="(item,index) in subjectList"
            :key="index"
            @click="toSearchSubjectList(item)"
            class="subject-list-item font-size-14 cursor"
            >
            {{ item.subjectName }}
        </span>
      </div>
     </div>
      <!-- 特色专题 -->
      <div class="special_container">
        <div class="special_container-title flex-row-justify-space-between">
          <p class="font-size-24 special-top-tit">特色专题</p>
          <div class="flex cursor flex-row-align-center ">
            <p class="more font-size-14" @click="toMoreSpecial()">
              更多专题
            </p>
            <img style="top: 0px;" class="more-right" src="../../../../assets/more-right.png" alt/>
          </div>
        </div>
        <div class="special_part flex">
          <div class="special-item cursor" v-for="(items,index) in special.slice(0, 6)" 
           :key="index"  @click="toSearchTopic(items)">
            <img :src="items.topicImg" alt="" v-if="items.topicImg">
            <img src="https://v.libraryplus.bjadks.com/java/mrms/publicImg/special-list-default.png" alt="" v-else>  
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <!-- 分类、学科 -->
      <!-- <div class="search-content"> -->
        <!-- 馆藏分类 -->
        <!-- <div class="topic common_content">
          <p class="font-size-20" style="font-weight: 800;padding-bottom:20px;">馆藏分类</p>
          <div class="topic-list flex">
            <div
              v-for="(item,index) in categoryList"
              :key="index"
              class="topic-list-item"
              @click="toSearchCategory(item)"
            >
              <p class="topic-list-item-text font-size-14">{{ item.cateName }}</p>
            </div>
          </div>
        </div> -->
        <!-- 馆藏学科 -->
        <!-- <div class="topic common_content">
          <p class="font-size-20" style="font-weight: 800;padding-bottom:20px;">馆藏学科</p>
          <div class="topic-list flex">
            <div
              v-for="(item,index) in subjectList"
              :key="index"
              class="topic-list-item"
              @click="toSearchSubjectList(item)"
            >
              <p class="topic-list-item-text font-size-14">{{ item.subjectName }}</p>
            </div>
          </div>
        </div> -->
        <!-- 特色专题 -->
        <!-- <div class="topic common_content">
          <p class="font-size-20" style="font-weight: 800;padding-bottom:20px;">特色专题</p>
          <div class="topic-list flex">
            <div
              v-for="(item,index) in topics"
              :key="index"
              class="topic-list-item"
              @click="toSearchTopic(item)"
            >
              <p class="topic-list-item-text text-line-1 font-size-14 ">{{ item.topicName }}</p>
            </div>
          </div>
        </div> -->
      <!-- </div> -->
      <!-- 馆藏学科 -->
      <!-- 馆藏 -->
      <!-- <div class="collection_container margin-top-20">
        <p class="font-size-20" style="font-weight: 800;padding-top:20px;margin-left:30px;">{{ clients.collectionTheme }}</p>
        <div class="colletions-list flex">
          <div
            v-for="(item,index) in colls"
            :key="index"
            class="colletions-list-item flex-shrink cursor"
            @click="toDetail(item)"
            :class="{'margin-t':index>3}"
          >
            <div class="position-relative colletions-list-item-img">
              <div
                class="img"
                :style="{backgroundImage: 'url(' + item.preview + ')','background-position':'center','background-size':'100% 100%'}"
              />
              <div
                class="colletions-list-item-img-count flex-row-align-center position-absolute radius-clip-5"
              >
                <div v-if="item.pictureNumber>0" class="space flex-row-align-center">
                  <img src="../../../../assets/icon-lib-pic-count.png" />
                  <span class="font-color-white font-size-11">{{ item.pictureNumber }}</span>
                </div>
                <div v-if="item.videoNumber>0" class="space flex-row-align-center">
                  <img src="../../../../assets/icon-lib-video-count.png" />
                  <span class="font-color-white font-size-11">{{ item.videoNumber }}</span>
                </div>
                <div v-if="item.audioNumber>0" class="space flex-row-align-center">
                  <img src="../../../../assets/icon-lib-audio-count.png" />
                  <span class="font-color-white font-size-11">{{ item.audioNumber }}</span>
                </div>
                <div v-if="item.otherNumber>0" class="space flex-row-align-center">
                  <img src="../../../../assets/icon-lib-file-count.png" />
                  <span class="font-color-white font-size-11">{{ item.otherNumber }}</span>
                </div>
              </div>
            </div>
            <div class="colletions-list-item-tit">
              <span
                class="font-size-16 font-color-264480 text-line-1 font-bold"
                style="line-height: 24px;"
              >{{ item.collectionName }}</span>
            </div>
            <div class="colletions-list-item-des">
              <span
                class="font-size-13 font-color-666 text-line-3"
                style="line-height: 20px;"
              >{{ item.description }}</span>
            </div>
          </div>
        </div>
      </div> -->
      <!-- 数字特藏 -->
      <div class="colletions2">
        <div v-for="(item,index) in colls" :key="index" v-if="item.recommends.length > 0" class="moduleWrap flex"  >
          <div class="colletions2-left">
            <div class="top-title">{{ item.cateName }}</div>
            <div class="colletions2-container flex">
              <div class="colletions2-list flex">
                <div class="colletions2-list-item cursor" v-for="(itm,idx) in colls[index].recommends"  :key="idx" @click="toDetail(itm)">
                  <img :src="itm.preview" alt="">
                  <div class="colletions2-list-item-tit">
                    <span class="font-size-16 text-line-1">{{itm.collectionName}}</span>
                  </div>
                  <div class="colletions2-list-item-des">
                    <span class="font-size-12 text-line-2">{{ itm.description }}</span>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="colletions2-right flex-1">
            <div class="colletions2-more-title flex-row-justify-end cursor" @click="tosourcelist(item)">
              <p class="more font-size-14">更多馆藏
              </p>
              <img class="more-right" src="../../../../assets/more-right.png" alt/>
            </div>
            <div class="cursor" v-for="(activity, index) in  colls[index].latests" @click="toDetail(activity)">
              <div class="colletions2-right-item flex" cursor>
                <div class="colletions2-right-date">
                  <p class="font-size-18 font-bold" style="color: #fff;" v-if="">{{activity.latestsDay}}</p>
                  <p class="date-month">{{activity.latestsMonth}}月</p>
                </div>
                <el-tooltip class="item" effect="dark" :content="activity.collectionName" placement="top-start">
                  <div class="colletions2-right-content font-size-14 text-line-2 flex-1 cursor" > {{activity.collectionName}}</div>
                </el-tooltip>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- 纪事人物 、纪事地点-->
      <div class="tag-cloud margin-top-20">
        <div class="person">
          <span class="common_text">纪事人物</span>
          <personTagCloud :personList="personList" @toSearchPerson="toSearchPerson"></personTagCloud>
        </div>
        <div class="place">
          <span class="common_text">纪事地点</span>
          <placeTagCloud @toSearchPlace="toSearchPlace"></placeTagCloud>
        </div>
      </div>
      <!-- 展览 -->
      <div class="shows" style="margin-top:20px;">
        <div class="shows-list flex">
          <div class="shows-list-item flex-shrink" v-for="(item, index) in banners" :key="index">
            <div
              class="img radius-clip-5 cursor"
              :style="{backgroundImage: 'url(' + item.bannerImg + ')','background-position':'center','background-size':'cover'}"
              @click="bannerLink(item)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import countTo from 'vue-count-to';
import searchModel from "../../../../models/search.js";
import personTagCloud from "./personTagCloud";
import placeTagCloud from "./placeTagCloud";
import collapi from "../../../../api/collections.js";
import api from "../../../../api/home.js";
import comapi from "../../../../api/common.js";
import {
  getHomePageTopic
} from '@/api/special'
import {
  dateFormat
} from '@/utils/validate'
import {
  dateOnlyMonth,
  dateOnlyDate,
  dateToString
} from '@/utils/utils'
export default {
  name: 'Home',
  data() {
    return {
      banners: [
        {
          bannerImg:
            "https://img.libraryplus.bjadks.cn/library/1/20210408144512_9202.jpg"
        },
        {
          bannerImg:
            "https://img.libraryplus.bjadks.cn/library/1/20210408144512_9202.jpg"
        }
      ],
      collectionCountText: "",
      resourceCount: [],
      topics: null,
      fileMenuData: {},
      subjectList: [],
      categoryList: [],
      colls:null,
      startVal:0,
      clients:'',
      personList:[],
      special:[],
      searchType: 1,
      latestsMonth:'',
      latestsDay:'',
      bgType:''
      // inputValue: searchModel.keyword || '',
    };
  },
  components: {
    personTagCloud,
    placeTagCloud,
    countTo
  },
   mounted() {
    let that = this;
    this.referPerson();
    this.$store.dispatch('navigation/setNavigatorIndex', 0)
    setTimeout(() => {
      that.clients = that.$store.getters.application 
      let url = that.clients.backgroundImg; 
      let lastIndex = url.lastIndexOf('.');
      that.bgType = url.substring(lastIndex+1);
    console.log('secondLastSegment',secondLastSegment)
    }, 1200);

  },
  created() {
    this.request()
    this.searchType = searchModel.type
    this.resourceTypeCount();
    this.requesttopic();
    // this.requestKeyMemu();
    this.requestSubjectList();
    this.requestCategoryList();
    // this.requestcoll();
    this.requestbanner();
    this.getHomePageTopic()
    this.requestcollNew();
    // toSearchCategory;
  },
  watch: {
    type(newvalue, oldvalue) {
      if (newvalue !== oldvalue) {
        this.searchType = this.type
      }
    }
  },
  methods: {
    request() {
      const that = this
      comapi.collectionCount({ tenantId:this.$store.getters.tenantId, type: this.searchType }).then(r => {
        if (that.searchType === 1) {
          that.collectionCountText = '在' + r.data + '条数字馆藏中检索'
        } else if (that.searchType === 2) {
          that.collectionCountText = '在' + r.data + '条多媒体资源中检索'
        } else if (that.searchType === 3) {
          that.collectionCountText = '在' + r.data + '个用户中检索'
        }
      })
    },
    toSpecial(){
        this.$router.push('/special')
    },
     bannerLink(v) {
      window.open(v.bannerLink, '_blank')
    },
    // 更多专题
    toMoreSpecial(){
      this.$router.push({ name: "Special" });
    },
    // 更多特藏
    tosourcelist(v) {
      console.log('vvvv',v)
      //模块更多跳转
      this.$store.dispatch("search/setType", 1);
      this.$store.dispatch("search/setKeyword", "");
      searchModel.viewData = {
        params: { categoryId: v.id },
        display: v.cateName,
        type: "categoryId"
      };
      this.$router.push({ 
        path: '/collection',
        query:{
          u:'YueHui',
          name:v.cateName
      }});
      this.$store.dispatch('navigation/setNavigatorIndex', v.sortId)
    },

    toDetail(v) {
        const routeData = this.$router.resolve({
            name: 'Resource',
            query: {
            rsId: v.id,
            permission: v.permissionRange
            }
        })
        window.open(routeData.href, '_blank')
    },
    // 
    async getHomePageTopic() {
                const res = await getHomePageTopic({ tenantId:this.$store.getters.tenantId })
                console.log('res', res)
                this.loading = false
                this.totalSize = res.data.total
                this.special = res.data
            },
    //获取纪事人物
    referPerson(){
        let that =this;
            api.referPerson({ selectTenantId:this.$store.getters.tenantId  }).then(r => {
            console.log('rr',r)
            that.personList  = r.data.records

            console.log('rr',r)

        }).catch(err => {
            console.log(err)
        })
    },
    
      //获取馆藏 
    // requestcoll(){
    //     let that =this;
    //     api.requestcoll({ tenantId:this.$store.getters.tenantId  }).then(r => {
    //     that.colls = [];
    //     r.data.forEach((element,index)=> {
    //          if(index<6){
    //             that.colls.push(element);
    //          }
    //     });    
    // }).catch(err => {
    //     console.log(err)
    // })
    // },
    // 推荐馆藏分类
    requestcollNew() {
      let that =this;
      api.requestcollNew({ tenantId:this.$store.getters.tenantId}).then(r => {
        that.colls = [];
        that.colls = r.data
        that.colls.forEach((item,index)=>{
          if(item.recommends.length > 0){
            item.latests.forEach((itm,index) => {
              // console.log('item.createTime', item.createTime);
              // console.log('date', date);
              this.$set(itm , 'latestsMonth', dateOnlyMonth(new Date(itm.createTime)))
              this.$set(itm , 'latestsDay', dateOnlyDate(new Date(itm.createTime)))
              // this.latestsMonth = dateOnlyMonth(new Date(itm.createTime))
              // this.latestsMonth = dateOnlyDate(new Date(itm.createTime))
            // let day = dateFormat(date.getDate()+1)
              // console.log(month);
              // console.log(day月);
            })        
          }
      })
       
      })
      .catch(err => {
          console.log(err);
        });
    },
      
    toSearchCategory(v) {
      this.$store.dispatch("search/setType", 1);
      this.$store.dispatch("search/setKeyword", "");
      searchModel.viewData = {
        params: { categoryId: v.id },
        display: v.cateName,
        type: "categoryId"
      };
      this.$router.push({ name: "Collection" });
    },
    toSearchSubjectList(v) {
      this.$store.dispatch("search/setType", 1);
      this.$store.dispatch("search/setKeyword", "");
      searchModel.viewData = {
        params: { subjects: v.id },
        display: v.subjectName,
        type: "subjects"
      };
      this.$router.push({ name: "Collection" });
    },
    // 特色专题 更多
    toSearchTopic(v) {
      this.$store.dispatch("search/setType", 1);
      this.$store.dispatch("search/setKeyword", "");
      searchModel.viewData = {
        params: { specialSubject: v.id },
        display: v.topicName,
        type: "specialSubject"
      };
      // this.$router.push({ name: "Collection" });
      this.$router.push({ 
        name: "Specialdetail",  
        query: {
          id: v.id
        } 
      });
    },
    toSearchPerson(v) {
      console.log("vvvv", v);
      this.$store.dispatch("search/setType", 1);
      this.$store.dispatch("search/setKeyword", "");
      searchModel.viewData = {
        params: { personAffected: v.referValue },
        display: v.referValue,
        type: "personAffected"
      };
      this.$router.push({ name: "Collection" });
    },
    toSearchPlace(v) {
      console.log("vvvv", v);
      this.$store.dispatch("search/setType", 1);
      this.$store.dispatch("search/setKeyword", "");
      searchModel.viewData = {
        params: { areaAffected: v.id },
        display: v.name,
        type: "areaAffected"
      };
      this.$router.push({ name: "Collection" });
    },
    toSearch() {
      this.$store.dispatch("search/setType", 1);
      searchModel.viewData = { params: null, display: null, type: "" };
      this.$router.push({ name: "Collection" });
    },
    inputChane(v) {
      this.$store.dispatch("search/setKeyword", v.target.value);
    },
    //获取banner
    requestbanner() {
      const that = this;
      api
        .requestbanner({ tenantId: this.$store.getters.tenantId })
        .then(r => {
          that.banners = r.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取数量
    resourceTypeCount() {
      const that = this;
      api
        .resourceTypeCount({tenantId: this.$store.getters.tenantId})
        .then(r => {
          that.resourceCount = r.data;
          console.log("r.data", r.data);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取专题
    requesttopic() {
      let that = this;
      api
        .requesttopic({ tenantId: this.$store.getters.tenantId })
        .then(r => {
          that.topics = r.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取学科
    requestSubjectList() {
      let that = this;
      api
        .subjectList({ tenantId: this.$store.getters.tenantId })
        .then(r => {
          that.subjectList = [];
            r.data.forEach((element,index)=> {
                if(index<12){
                    that.subjectList.push(element);
                }
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取分类
    requestCategoryList() {
      let that = this;
      api
        .categoryList({ tenantId: this.$store.getters.tenantId })
        .then(r => {
          that.categoryList = [];
           r.data.forEach((element,index)=> {
                if(index<12){
                    that.categoryList.push(element);
                }
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    requestKeyMemu() {
      let menuParams = {};
      menuParams.tenantId = this.$store.getters.tenantId;
      menuParams.tenantId = this.$store.getters.tenantId;
      collapi.searchFileMenu(menuParams).then(r => {
        that.fileMenuData = r.data;
      });
    }
  }
};
</script>
<style src="@/styles/pc.css" scoped></style>
<style lang="scss">
  .video-bg{
     z-index: 0;
    position: absolute;
    height: 100%;
    left: 0;
    right: 0;
    width:100%;
    background:rgba(0, 0, 0, .9);
  }
  .el-tooltip__popper.is-dark {
    background-color: #ccc !important;
  }

  .el-tooltip__popper[x-placement^=top] .popper__arrow::after{
    border-top-color:#ccc !important;
  } 

  .el-tooltip__popper[x-placement^=top] .popper__arrow{
    border-top-color:#ccc !important;
  }
  .el-tooltip__popper.is-dark{
    background: #ccc !important;
  }
</style>
<style lang="scss" scoped>


.new-home {
  width: 100%;
  background: #f3f4f9;
  .banner-container {
    background-repeat: no-repeat !important;
    margin-top: 70px;
    height: 600px;
    /* background: url("../../../../assets/banner.png") no-repeat; */
    background-size: 100% 100%;
    background-position: center !important;
    position: relative;
  }
  .search-wrap {
    text-align: center;
     z-index: 1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .banner-title {
      font-weight: 250;
      font-family: AlibabaPuHuiTi_2_35_Thin;
      padding-top: 113px;
      display: inline-block;
    }
    .search-input {
      height: 50px;
      width: 550px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 7px;
      margin: 20px auto;
    }
    .input {
      padding: 0 13px;
    }

    input {
      height: 100%;
      width: 100%;
      border: none;
    }
    input:focus {
      outline: none;
    }

    .search-input-button {
      width: 80px;
      height: 36px;
    }

    .num-container {
      color: #fff8c6;
      display: flex;
      align-items: center;
      justify-content: center;
      .num-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 52px;
      }
      .num-item span:nth-child(1) {
        font-size: 24px;
        font-weight: 800;
        letter-spacing: 0em;
      }
      .num-item span:nth-child(2) {
        font-size: 14px;
      }
    }
  }
  .shows {
    width: 1240px;
    height: 200px;
    margin: 0 auto;
  }

  .shows-list {
    flex-wrap: nowrap;
  }

  .shows-list-item {
    width: 600px;
    height: 200px;
    margin-right: 40px;
  }

  .shows-list-item:last-child {
    margin-right: 0;
  }
  .shows-list-item .img {
    /* width: 100%; */
    height: 100%;
    background-color: bisque;
  }
  .search-content {
    width: 1230px;
    height: 235px;
    border-radius: 10px;
    background: #ffffff;
    padding: 20px 30px 30px 0px;
    box-sizing: border-box;
    display: flex;
    .common_content {
      flex: 1;
      padding-left: 30px;
    }
    // margin: 0 auto;
  }
  .tag-cloud {
    height: 380px;
    border-radius: 10px;
    background: #ffffff;
    display: flex;
    .person {
      flex: 1;
      border-right: 1px solid #efefef;
      position: relative;
    }
    .place {
      flex: 1;
      position: relative;
    }
    .common_text {
      font-family: AlibabaPuHuiTi_2_95_ExtraBold;
      font-size: 20px;
      font-weight: 800;
      /* 正文色/正文色 */
      color: #1a1a1a;
      left: 30px;
      top: 20px;
      position: absolute;
      z-index: 999;
    }
  }
  .subject-and-special {
    width: 100%;
    background: #fff;
    margin: 0 auto;
    margin-bottom: 30px;
  }
  .content {
    margin: 0 auto;
    width: 1240px;
    margin-bottom:40px ;
    /* width: 1230px; */
    /* position: relative; */
    /* top: -100px; */
  }
  .topic-list {
    flex-wrap: wrap;
  }
  .topic-list-item {
    width: 31%;
    height: 30px;
    border-radius: 5px;
    background: #f3f4f9;
    padding: 0 10px;
    line-height: 30px;
    margin-right: 5px;
    margin-bottom: 5px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
  .special_part{
    flex-wrap: wrap;
    /* justify-content:space-between; */
  }
  .special_container{    
    width: 1240px;
    min-height: 280px;
    margin: 0 auto;
    padding-bottom: 20px;
    /* border-radius: 10px; */
    background: #ffffff;
  }
  .special_container-title{
    height: 80px;
  }
  /* .special_container-title:first-child p{

    padding-top:24px;
    padding-bottom:19px;
  } */
  .special-top-tit{
    font-weight: bold;
    padding-top:24px;
    padding-bottom:19px;
  }
  .special-item {
        box-sizing:content-box;
        width: 400px;  
        height: 160px; 
        border-radius: 5px;
        margin-bottom:  20px;
        margin-right: 20px;
        background-color: #eee;  
        overflow: hidden;
    }
    .special-item:nth-child(3n){
      /* margin-bottom: 0px; */
      margin-right: 0px;
    }

    .special-item img{
        width: 768px;
        margin-bottom: 20px;
        height: 160px;
        background-color: #eee;
        opacity: .9;
        margin-left: -184px;
    }
    .special-item img:hover{
        opacity: 1;
        transition: all 3s;
    }
  .collection_container {
    height: 700px;
    border-radius: 10px;
    background: #ffffff;
  }
   .colletions-list {
    flex-wrap: wrap;
    overflow: hidden;
    margin-top: 20px;
  }

   .colletions-list-item {
    margin-left: 30px;
    width: 270px;
  }

 .colletions-list-item:last-child {
    margin-right: 0;
  }

  .colletions-list-item .colletions-list-item-img {
    width: 100%;
    height: 186px;
  }

   .colletions-list-item-img .img {
    width: 100%;
    height: 180px;
    background-color:antiquewhite;
    background-repeat: no-repeat;
    overflow: hidden;
    border-radius: 5px;
  }

.colletions-list-item-img-count {
    bottom: 5px;
    right: 5px;
    height: 20px;
    padding: 0 9px 0 4px;
    background-color: rgba(0, 0, 0, 0.6);
  }

 .colletions-list-item-tit {
    margin-top: 9px;
    // height: 54px;
  }
  .colletions-list-item-des{
      padding-top: 12px;
  }
  .margin-t{
      margin-top: 28px;
  }
  .more{
    color: #3D3D3D;
    font-weight: normal;
  }
  .subject_navbar{
    width: 1240px;
    height: 60px;   
    margin: 0 auto;
    line-height: 60px;
    text-align: center;
    color: #333333;
    /* border-bottom: solid 1px #EFEFEF; */
  }

  .subject-list-item{
    /* width: 1240px;      */
    margin-right: 36px;
  }
  .subject-list-item:last-child {
    margin-right: 0;
  }
  .colletions2{
    width: 1240px;
    
  }
  .moduleWrap{
    height: 350px;
    background-color: #fff;
    margin-bottom: 30px;
    border-radius: 5px;
    
  }
  .colletions2-left{
    width: 850px;
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 32px;
    border-radius: 5px;
    background: #FFFFFF;

    box-shadow: 0px 0px 60px 0px rgba(0, 0, 0, 0.05);
    /* padding-bottom: 32px; */
  }
  .top-title{
    height: 76px;
    padding-top: 22px;
    padding-bottom: 18px;
    font-size: 24px;
    font-weight: bold;
  }
  .colletions2-container{

  }
  .colletions2-list-item{
    width: 250px;
    height: 240px;
    margin-right: 20px;
    /* background-color: rgb(246, 181, 181); */
  }
  .colletions2-list-item:last-child {
    margin-right: 0;
  }
  .colletions2-list-item img{
    width: 100%;
    height: 165.25px;
    border-radius: 5px;
   
    /* background-color: rgb(123, 66, 75); */
  }

  .colletions2-list-item-tit{
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: 800;
    color: #000000;
  }
  .colletions2-list .colletions2-list-item-des{
    font-family: Alibaba PuHuiTi 2.0;
    height: 36px;
    line-height: 18px;
    color: #999999;
  }
  .colletions2-right{
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 32px;
  }
  .colletions2-more-title{
    height: 76px;
    padding-top: 30px;
    padding-bottom: 25px;
    text-align: right;
  }
  .colletions2-right-item{
    margin-bottom: 15px;
    height: 36px;
  }
  .colletions2-right-date{
    width: 31px;
    height: 36px;
    text-align: center;
    border-radius: 4px;
    background: #3739AA;
    padding-top: 2px;
    padding-bottom: 4px;
    margin-right: 10px;
  }

  .date-month{
    font-size: 10px;
    color: #fff;
    /* text-align: justify; */
  }
  .colletions2-right-content{
    /* width: 288px; */
    height: 36px;
    line-height: 18px;
    color: #3D3D3D;
    
  }
  .more-right{
    width: 6px;
    height: 10px;
    margin-left: 6px;
    position: relative;
    top: 3px;
    /* padding-top: 4px; */
  }
}
</style>